// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modals_backdrop__30uMx","modal":"Modals_modal__3Bdop"};